import FullPageLoader from "@Components/FullPageLoader";
import loadable from "@loadable/component";
import loadData from "@Pages/BookingDetails/data";

const RentPayment = loadable(() => import("./RentPayment"), {
  fallback: <FullPageLoader />,
});

export default RentPayment;
export { loadData };
